import React from 'react';
import { REDUCER_NAME } from './../../reducer';
import { connect } from 'react-redux';
import { getDataFollowKeyByDot } from '../../../../helpers/Common';
import { formatTextFloat, formatPrice, val } from '../../../../helpers/Text';
import { I18n } from 'react-redux-i18n';
import { isTicker } from '../../../../helpers/Common';
import { formatDataBidAsk } from '../../../../helpers/Common';
import { compose } from 'redux';
import { withComponentId } from './../../../../common/ComponentIdContext';

const indexSumaryData = {
  OPEN_PRICE: 'openPrice',
  HIGHEST_PRICE: 'highestPrice',
  LOWEST_PRICE: 'lowestPrice',
};

class IndexInfo extends React.Component {
  formatValueIndexInfo(value, dataMap) {
    const { indexSumary } = this.props;
    let valueArr = [];
    if (isTicker(indexSumary)) {
      valueArr = formatTextFloat(
        formatPrice(getDataFollowKeyByDot(value, dataMap)),
      ).split('.');
    } else {
      valueArr = formatTextFloat(getDataFollowKeyByDot(value, dataMap)).split(
        '.',
      );
    }
    let valueBeforeDot = valueArr[0];
    let valueAfterDot = valueArr[1];
    return val(valueBeforeDot) + '.' + val(valueAfterDot);
  }

  renderCellIndexInfo = (indexInfo, value) => {
    return (
      <div className="item">
        <div className="main-text">{indexInfo}:</div>
        <div className="sub-text font-weight-bold">{value}</div>
      </div>
    );
  };

  renderFirstRowInfo = (indexInfo, indexSumary) => {
    const openPrice = this.formatValueIndexInfo(
      indexSumary,
      indexSumaryData.OPEN_PRICE,
    );
    const highestPrice = this.formatValueIndexInfo(
      indexSumary,
      indexSumaryData.HIGHEST_PRICE,
    );
    const lowestPrice = this.formatValueIndexInfo(
      indexSumary,
      indexSumaryData.LOWEST_PRICE,
    );

    return (
      <div className="item-infor--first-row">
        {this.renderCellIndexInfo(indexInfo.Open, openPrice)}
        {this.renderCellIndexInfo(indexInfo.Hight, highestPrice)}
        {this.renderCellIndexInfo(indexInfo.Low, lowestPrice)}
      </div>
    );
  };

  getBidAskRealtimeData = () => {
    const { bidAskRealtimeData, currentSearch } = this.props;

    return bidAskRealtimeData[currentSearch.code];
  };

  getBest1Bid = indexInfor => {
    const bidAskRealtimeData = this.getBidAskRealtimeData();
    if (bidAskRealtimeData) {
      return bidAskRealtimeData.best1Bid;
    }

    return indexInfor.best1Bid;
  };

  getBest1Offer = indexInfor => {
    const bidAskRealtimeData = this.getBidAskRealtimeData();
    if (bidAskRealtimeData) {
      return bidAskRealtimeData.best1Offer;
    }

    return indexInfor.best1Offer;
  };

  getBest1BidVolume = indexInfor => {
    const bidAskRealtimeData = this.getBidAskRealtimeData();

    return (bidAskRealtimeData || indexInfor).best1BidVolume;
  };

  getBest1OfferVolume = indexInfor => {
    const bidAskRealtimeData = this.getBidAskRealtimeData();

    return (bidAskRealtimeData || indexInfor).best1OfferVolume;
  };

  formatBidAskValue = bidAsk => {
    const { indexSumary } = this.props;
    if (isTicker(indexSumary)) {
      return formatTextFloat(formatPrice(bidAsk));
    }

    return formatTextFloat(bidAsk);
  };

  renderSecondRowInfo = (indexInfo, indexInfor) => {
    const { currentSearch, data, indexSumary } = this.props;
    const best1Bid = this.getBest1Bid(indexInfor);
    const best1Offer = this.getBest1Offer(indexInfor);

    if (currentSearch && currentSearch.isTicker) {
      let bidValue = this.renderCellIndexInfo(
        indexInfo.Bid,
        formatDataBidAsk(
          best1Bid,
          this.getBest1BidVolume(indexInfor),
          indexInfor.tradingDate,
          false,
          data.marketStatus || indexSumary.marketStatus,
          indexInfor.comGroupCode,
        ) || this.formatBidAskValue(best1Bid),
      );

      let askValue = this.renderCellIndexInfo(
        indexInfo.Ask,
        formatDataBidAsk(
          best1Offer,
          this.getBest1OfferVolume(indexInfor),
          indexInfor.tradingDate,
          false,
          data.marketStatus || indexSumary.marketStatus,
          indexInfor.comGroupCode,
        ) || this.formatBidAskValue(best1Offer),
      );
      return (
        <div className="item-infor--second-row">
          {bidValue}
          {askValue}
        </div>
      );
    }
    return <div className="item-infor--second-row mt-8 pt-10" />;
  };

  render() {
    const indexInfoI18n = I18n.t('priceData.indexInfo');
    const { indexInfor, indexSumary } = this.props;

    return (
      <div className="item-infor mr-3 ml-3">
        {this.renderFirstRowInfo(indexInfoI18n, indexSumary)}
        {this.renderSecondRowInfo(indexInfoI18n, indexInfor)}
      </div>
    );
  }
}

const mapStateToProps = (state, { componentId }) => {
  return {
    i18n: state.i18n,
    indexInfor: state[REDUCER_NAME].listMultiComponent[componentId].indexInfor,
    indexSumary:
      state[REDUCER_NAME].listMultiComponent[componentId].indexSumary,
    currentSearch:
      state[REDUCER_NAME].listMultiComponent[componentId].currentSearch,

    bidAskRealtimeData:
      state[REDUCER_NAME].listMultiComponent[componentId].bidAskRealtimeData,
  };
};

export default compose(
  withComponentId,
  connect(mapStateToProps),
)(IndexInfo);
